import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Box, Button, Table, TableBody, TableCell,
  TableHead, TableRow, Paper, IconButton, Chip, Alert, CircularProgress,
  FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../services/api';

const AdminVehicleSeries = () => {
  const navigate = useNavigate();
  const [series, setSeries] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [filterBrand, setFilterBrand] = useState('');
  const [filterModel, setFilterModel] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    axiosInstance.get('/vehiclebrands').then(res => setBrands(res.data)).catch(() => {});
    fetchSeries();
  }, []);

  const fetchSeries = async (modelId = '', brandId = '') => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (modelId) params.append('modelId', modelId);
      if (brandId) params.append('brandId', brandId);
      const res = await axiosInstance.get(`/vehicleseries?${params}`);
      setSeries(res.data);
    } catch {
      setError('Seriler yüklenemedi.');
    } finally {
      setLoading(false);
    }
  };

  const handleBrandFilter = async (val) => {
    setFilterBrand(val);
    setFilterModel('');
    if (val) {
      const res = await axiosInstance.get(`/vehiclemodels?brandId=${val}`);
      setModels(res.data);
      fetchSeries('', val);
    } else {
      setModels([]);
      fetchSeries();
    }
  };

  const handleModelFilter = (val) => {
    setFilterModel(val);
    fetchSeries(val, filterBrand);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu seriyi silmek istediğinizden emin misiniz?')) return;
    try {
      const token = localStorage.getItem('adminToken');
      await axiosInstance.delete(`/vehicleseries/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSeries(prev => prev.filter(s => s.id !== id));
    } catch {
      setError('Silme işlemi başarısız.');
    }
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h5" fontWeight={700}>Araç Serileri / Nesilleri</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/admin/vehicles/series/new')}>
          Yeni Seri
        </Button>
      </Box>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <FormControl sx={{ minWidth: 180 }}>
          <InputLabel>Marka Filtrele</InputLabel>
          <Select label="Marka Filtrele" value={filterBrand} onChange={e => handleBrandFilter(e.target.value)}>
            <MenuItem value="">Tümü</MenuItem>
            {brands.map(b => <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 180 }} disabled={!filterBrand}>
          <InputLabel>Model Filtrele</InputLabel>
          <Select label="Model Filtrele" value={filterModel} onChange={e => handleModelFilter(e.target.value)}>
            <MenuItem value="">Tümü</MenuItem>
            {models.map(m => <MenuItem key={m.id} value={m.id}>{m.name}</MenuItem>)}
          </Select>
        </FormControl>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : (
        <Paper>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: 'primary.main' }}>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Seri / Nesil</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Model</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Marka</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Yıllar</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Durum</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }} align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {series.map(s => (
                <TableRow key={s.id} hover>
                  <TableCell><strong>{s.name}</strong></TableCell>
                  <TableCell>{s.modelName}</TableCell>
                  <TableCell>{s.brandName}</TableCell>
                  <TableCell>{s.yearStart} – {s.yearEnd || 'günümüz'}</TableCell>
                  <TableCell>
                    <Chip label={s.status ? 'Aktif' : 'Pasif'} color={s.status ? 'success' : 'default'} size="small" />
                  </TableCell>
                  <TableCell align="right">
                    <IconButton color="primary" onClick={() => navigate(`/admin/vehicles/series/edit/${s.id}`)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton color="error" onClick={() => handleDelete(s.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {series.length === 0 && (
                <TableRow><TableCell colSpan={6} align="center">Henüz seri eklenmemiş.</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Container>
  );
};

export default AdminVehicleSeries;
